import { generators } from 'stores';

export const types = {
  RENEW_SUBSCRIPTION_TOGGLE_REVIEW_REQUEST:
    'REVIEWS/RENEW_SUBSCRIPTION_TOGGLE_REVIEW_REQUEST',
  RENEW_SUBSCRIPTION_TOGGLE_REVIEW_SUCCESS:
    'REVIEWS/RENEW_SUBSCRIPTION_TOGGLE_REVIEW_SUCCESS',
  RENEW_SUBSCRIPTION_TOGGLE_REVIEW_FAILURE:
    'REVIEWS/RENEW_SUBSCRIPTION_TOGGLE_REVIEW_FAILURE',
};

export const initialState = {
  error: null,
  errorCode: null,
  isLoading: false,
  isUpdating: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.RENEW_SUBSCRIPTION_TOGGLE_REVIEW_REQUEST:
      return { ...state, isUpdating: true, error: null, errorCode: null };
    case types.RENEW_SUBSCRIPTION_TOGGLE_REVIEW_SUCCESS:
      return { ...state, isUpdating: false };
    case types.RENEW_SUBSCRIPTION_TOGGLE_REVIEW_FAILURE:
      return {
        ...state,
        isUpdating: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    default:
      return state;
  }
};

export const actions = {
  fetchPullRequests: (
    source,
    sourceUUID,
    nextPageUrl,
    status,
    pullRequestUUID,
    pullRequestAuthor,
    title,
    repositoryUUID,
    hasReviews,
    pageNumber
  ) => {
    if (source === 'org') {
      if (pullRequestUUID) {
        return generators.pullRequests.entries.request({
          organizationUUID: sourceUUID,
          uuid: pullRequestUUID,
          status,
        });
      }

      return generators.organizations.pullRequests.pages.request({
        organizationUUID: sourceUUID,
        status,
        author: pullRequestAuthor,
        page: nextPageUrl,
        reset: Boolean(!nextPageUrl),
        title,
        repositoryUUID,
        hasReviews,
        pageNumber,
      });
    }

    if (pullRequestUUID) {
      return generators.pullRequests.entries.request({
        projectUUID: sourceUUID,
        uuid: pullRequestUUID,
        status,
      });
    }

    return generators.projects.pullRequests.pages.request({
      projectUUID: sourceUUID,
      status,
      author: pullRequestAuthor,
      page: nextPageUrl,
      reset: Boolean(!nextPageUrl),
      title,
      pageNumber,
    });
  },

  cancelReview: (repoUUID, pullRequestUUID, organizationUUID, status) =>
    generators.pullRequests.toggleReview.request({
      uuid: pullRequestUUID,
      enabled: false,
    }),
  requestReview: (repoUUID, pullRequestUUID, organizationUUID, status) =>
    generators.pullRequests.toggleReview.request({
      uuid: pullRequestUUID,
      enabled: true,
    }),

  renewSubscriptionAndToggleReview: (pullRequestUUID, organizationUUID) => ({
    type: types.RENEW_SUBSCRIPTION_TOGGLE_REVIEW_REQUEST,
    pullRequestUUID,
    organizationUUID,
    enabled: true,
  }),
};
